import { FilterOutlined } from '@ant-design/icons';
import { Button, Col } from 'antd';
import React, { useState } from 'react';

import FilterDrawer from './FilterDrawer';
import FilterItem from './FilterItem';
import FilterToolbar from './FilterToolbar';

interface FilterProps {
  onClear?: () => void;
  children: React.ReactNode[] | React.ReactNode;
}

const Filter = ({ onClear, children }: FilterProps) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  const hiddenFilters = React.Children.toArray(
    React.Children.map(children, (child) =>
      React.isValidElement(child) && child.type === FilterItem ? child : null
    )
  ).filter((child) => React.isValidElement(child) && !child.props.alwaysOn);

  return (
    <>
      <FilterToolbar onClear={onClear}>
        {children}
        {hiddenFilters.length > 0 && (
          <Col>
            <Button data-testid="extra-filters-button" onClick={() => setIsDrawerOpen(true)}>
              <FilterOutlined />
            </Button>
          </Col>
        )}
      </FilterToolbar>
      {hiddenFilters.length > 0 && (
        <FilterDrawer
          open={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          onDone={() => setIsDrawerOpen(false)}
          onClear={() => {
            onClear && onClear();
            setIsDrawerOpen(false);
          }}
        >
          {children}
        </FilterDrawer>
      )}
    </>
  );
};

export default Filter;
